import { render, staticRenderFns } from "./FaqsBlock.vue?vue&type=template&id=578acbab&scoped=true&"
import script from "./FaqsBlock.vue?vue&type=script&lang=js&"
export * from "./FaqsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578acbab",
  null
  
)

export default component.exports